import React from 'react';

/**
 * SUIVI DE STAGE — la barre de progression à dix segments (lot 3.1)
 * =================================================================
 * Spec     : doc/modules/suivi_de_stage.md §1 « Barre de progression : 10 étapes »
 * Maquette : doc/maquettes/suivi_de_stage_maquette.html (classe `.seg`)
 *
 * ── AUCUN TEXTE SOUS LA BARRE, ET C'EST UNE RÈGLE ──────────────────────────
 * La spec l'interdit explicitement. La lisibilité repose donc sur **la bulle au
 * survol** de chaque segment, qui porte le nom de l'étape ET son état.
 *
 * ⚠️ **La légende de l'en-tête de colonne a été RETIRÉE** le 2026-09-16 (écart
 * E43) : elle venait du test S15, la maquette ne la dessine pas, et Bertrand a
 * tranché que la spec avait tort. Conséquence directe — **la bulle est devenue
 * la SEULE clé de lecture** des dix carrés : elle n'est plus un confort.
 *
 * ⚠️ Le compteur « 4/9 » à DROITE de la barre est conservé (écart **E13**) : la
 * spec interdit du texte *sous* la barre, la maquette le place *à côté*. Ce n'est
 * pas la même chose, et il répond à la seule question qu'on se pose en regardant
 * dix carrés — « où en est-on ? ».
 *
 * ⚠️ Le dénominateur compte les étapes EFFECTIVES. Un BUT1 sans visite affiche
 * « 0/9 », pas « 0/10 » : sinon son dossier paraîtrait éternellement incomplet.
 * Le calcul vit au serveur, pas ici — voir `stageDashboardService`.
 */

/** Les couleurs de la spec : vert fait · orange en cours · gris à venir · transparent N/A. */
const COULEURS = {
    fait:    '#16a34a',
    encours: '#f59e0b',
    alerte:  '#ea580c',
    avenir:  '#e2e8f0',
    na:      '#e2e8f0'
};

function StageBarreProgression({ segments, faites, total, compact = false }) {
    if (!Array.isArray(segments) || !segments.length) return <span style={{ color: '#94a3b8' }}>—</span>;

    const hauteur = compact ? 8 : 10;
    const largeur = compact ? 18 : 22;

    return (
        <div className="stg-barre">
            {segments.map((s) => (
                <div
                    key={s.numero}
                    className="seg"
                    data-tip={s.bulle}
                    style={{
                        width: largeur, height: hauteur, borderRadius: 4,
                        background: COULEURS[s.etat] || COULEURS.avenir,
                        // Le segment N/A est le MÊME gris, atténué : il doit se lire
                        // comme « sans objet », pas comme « pas encore fait ».
                        opacity: s.etat === 'na' ? 0.4 : 1
                    }}
                />
            ))}
            <span className={'stg-barre-compteur' + (faites === total ? ' complet' : '')}>
                {faites}/{total}
            </span>
        </div>
    );
}

export default StageBarreProgression;
